module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/zws1qy/tc-custom/9780795351938.jpg?1698091112750",
      "alt": "This image is the cover for the book Alec Forbes of Howglen, The Cullen Collection"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Alec Forbes of Howglen, The Cullen Collection\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("A masterful and timeless novel from the renowned Scottish author—the work that established his place in the pantheon of British literature.")]), _c('br'), _c('br'), _vm._v(" Released in 1865 as the second of his major Scottish novels, many consider "), _c('i', [_vm._v("Alec Forbes of Howglen ")]), _vm._v("George MacDonald’s most uniformly cohesive work of fiction. Intensely Scottish in flavor, like its predecessor "), _c('i', [_vm._v("David")]), _vm._v(" "), _c('i', [_vm._v("Elginbrod")]), _vm._v(", the thick Doric dialect of much of the novel was relished by Victorians. Set in MacDonald’s hometown of Huntly, this story of Alec Forbes and Annie Anderson contains many autobiographical glimpses of MacDonald’s own boyhood, capturing the delights of youth and the anguish of first loves. While preserving the flavor of MacDonald’s original, this updated edition by Michael Phillips translates the Scottish dialect, in which most of MacDonald’s Scottish stories are written, into readable English.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      George MacDonald, Michael Phillips\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0